export { CarComplectationCollapsed } from './CarComplectationCollapsed';
